import { render } from "./formal_document_question_selector_view.html?vue&type=template&id=1e320c3d&scoped=true&external"
import script from "./formal_document_question_selector.js?vue&type=script&lang=js&external"
export * from "./formal_document_question_selector.js?vue&type=script&lang=js&external"

import "./FormalDocumentQuestionSelector.vue?vue&type=style&index=0&id=1e320c3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e320c3d"]])

export default __exports__